import { render, staticRenderFns } from "./ItemSearchDialog.vue?vue&type=template&id=55d2d5ec&scoped=true&"
import script from "./ItemSearchDialog.vue?vue&type=script&lang=ts&"
export * from "./ItemSearchDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSearchDialog.vue?vue&type=style&index=0&id=55d2d5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d2d5ec",
  null
  
)

export default component.exports